import FxRateRefreshScheduleTable from "./FxRateRefreshScheduleTable";
import FxRatesTable from "./FxRatesTable";
import { useEffect } from "react";
import { useLayout } from "@/context/LayoutContext";

export default function FxRatesPage() {
  const { setIsFullPage } = useLayout();

  useEffect(() => {
    setIsFullPage(false);

    return () => setIsFullPage(true);
  }, [setIsFullPage]);

  return (
    <>
      <div className="mb-3">
        <FxRatesTable />
      </div>
      <div className="mb-3">
        <FxRateRefreshScheduleTable />
      </div>
    </>
  );
}
